import { Component, OnInit, ViewChild, ErrorHandler } from '@angular/core';

import { Http, Response } from '@angular/http';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError, config } from 'rxjs';

import { NgbModal, ModalDismissReasons, NgbDropdownConfig, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { FormControl } from '@angular/forms';

import { CompletedSurvey } from '../../../models/completed-survey.model';
import { QuestionCompiled } from '../../../models/question-compiled.model';
import { Section } from '../../../models/section.model';
import { Page } from '../../../models/page.model';

import { ModalSurveyComponent } from '../modal-survey/modal-survey.component';

import { SurveyService } from '../services/survey.service';

import { ToastrService } from 'ngx-toastr';
import { TooltipPosition } from '@angular/material';



@Component({
  selector: 'app-survey',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.css']
})
export class SurveyComponent implements OnInit {

  isLinear = false;
  panelOpenState = false;

  //LocalStorage Elements.
  localFacilities = localStorage.getItem('localFacilities');
  localID = localStorage.getItem('localID');
  localTags = localStorage.getItem('localTags');
  localIDElaboration = localStorage.getItem('localIDElaboration');
  localStateAnalysis = localStorage.getItem('localStateAnalysis');
  localModules = localStorage.getItem('localModules');

  facility = JSON.parse(this.localFacilities);
  id = JSON.parse(this.localID);
  tag = JSON.parse(this.localTags);
  idElaboration = JSON.parse(this.localIDElaboration);
  state = JSON.parse(this.localStateAnalysis);
  modules = JSON.parse(this.localModules);

  currentFacility = this.facility[this.id];
  currentTag = this.tag[this.currentFacility.myFacilities.IdTag]

  //Icon NavBar
  markerImage: any = require("../image/logo/locationIcon.png")
  homeImage: any = require("../image/navbar/backHomeIcon.svg");
  summaryImage: any = require("../image/navbar/summary.svg");
  analysisImage: any = require("../image/navbar/analysis.svg");
  roiImage: any = require("../image/navbar/roi.svg");
  mdiImage: any = require("../image/navbar/mdi.svg");
  pprImage: any = require("../image/navbar/ppr.svg");

  survey: any;
  partialSurvey: any;
  surveyToRead: any;
  answerDictionary: { [AnswerID: number]: any } = {};

  completedSurvey: CompletedSurvey;
  page: Page;
  section: Section;
  questionCompiled: QuestionCompiled;

  positionOptions: TooltipPosition[] = ['right'];
  position = new FormControl(this.positionOptions[0]);
  _opened: boolean = false;


  constructor(
    private router: Router,
    private modalService: NgbModal,
    private translate: TranslateService,
    private surveyService: SurveyService,
    private toastr: ToastrService,
    private modal: NgbActiveModal,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    this.matIconRegistry.addSvgIcon("back", this.domSanitizer.bypassSecurityTrustResourceUrl(this.homeImage));
    this.matIconRegistry.addSvgIcon("all", this.domSanitizer.bypassSecurityTrustResourceUrl(this.summaryImage));
    this.matIconRegistry.addSvgIcon("Analysis", this.domSanitizer.bypassSecurityTrustResourceUrl(this.analysisImage));
    this.matIconRegistry.addSvgIcon("MDI", this.domSanitizer.bypassSecurityTrustResourceUrl(this.mdiImage));
    this.matIconRegistry.addSvgIcon("PPR", this.domSanitizer.bypassSecurityTrustResourceUrl(this.pprImage));
    this.matIconRegistry.addSvgIcon("ROI", this.domSanitizer.bypassSecurityTrustResourceUrl(this.roiImage));
  }

  modalReference: any;
  anwserSelected: any;


  ngOnInit() {

    this.translate.use(localStorage.getItem('localLanguage'));

    //Check status of facility
    if (this.state == 'CompilazioneNonAvviata') {
      this.getSurvey();
      this.isEmpty();
    } else if (this.state == "CompilazioneParziale") {
      this.getSurvey();
    } else {
      this.surveyRead();
    }
  }

  _toggleSidebar() {
    this._opened = !this._opened;
  }

  //Method used to open modal survey send.
  openVerticallyCentered(content) {
    this.modalReference = this.modalService.open(content, { centered: true });
  }
  //Method used to close modal survey send.
  close() {
    this.modalReference.close();
  }

  //Method used to open modal survey component.
  openModalSurvey(content) {
    this.modalService.open(ModalSurveyComponent, { centered: true });
  }

  //Method used to create survey Object.
  createData(pages) {
    this.completedSurvey = new CompletedSurvey;
    for (let value of pages) {
      this.page = new Page;
      this.page.PageId = value.ID;

      for (let section of value.Sections) {
        this.section = new Section;
        this.section.SectionId = section.ID;

        for (let questions of section.Questions) {
          this.questionCompiled = new QuestionCompiled;
          this.questionCompiled.QuestionId = questions.ID
          this.questionCompiled.AnswerId = 0;
          this.questionCompiled.AnswerText = '';
          this.section.QuestionsCompiled.push(this.questionCompiled);
        }
        this.page.Sections.push(this.section);
      }
      this.completedSurvey.Pages.push(this.page);
    }
    this.completedSurvey.IdElaborazioneCompilativa = this.idElaboration;
    this.completedSurvey.isCompleted = false;
  }

  //Method used to create partial survey fill Object.
  createDataPartial(pages) {
    this.completedSurvey = new CompletedSurvey;
    for (let page of pages) {
      this.page = new Page;
      this.page.PageId = page.PageId;
      for (let section of page.Sections) {
        this.section = new Section;
        this.section.SectionId = section.SectionId;
        for (let question of section.QuestionsCompiled) {
          this.questionCompiled = new QuestionCompiled;
          this.questionCompiled.QuestionId = question.QuestionId;
          this.questionCompiled.AnswerId = question.AnswerId;
          this.questionCompiled.AnswerText = question.AnswerText;
          this.section.QuestionsCompiled.push(this.questionCompiled);
        }
        this.page.Sections.push(this.section);
      }
      this.completedSurvey.Pages.push(this.page);
    }
    this.completedSurvey.IdElaborazioneCompilativa = this.idElaboration;
    this.completedSurvey.isCompleted = false;
    localStorage.setItem('localSurveyCompiled', JSON.stringify(this.completedSurvey));
  }

  //Method used to fill survey object with answers.
  getValue(event) {
    for (let page of this.completedSurvey.Pages) {
      for (let section of page.Sections) {
        for (let question of section.QuestionsCompiled) {
          if (question.QuestionId == event.value.QuestionRefID) {
            this.questionCompiled = question;
            this.questionCompiled.AnswerId = event.value.ID;
            this.questionCompiled.AnswerText = event.value.Text;
          }
        }
      }
    }
    //Save survey completed in LocalStorage.
    localStorage.setItem('localSurveyCompiled', JSON.stringify(this.completedSurvey));
  }

  //Method used to call Api surveyUpsert.
  nextButton() {
    this.surveyUpsert(this.completedSurvey.isCompleted);
  }

  //Method used to save survey.
  saveButton() {
    this.surveyUpsert(this.completedSurvey.isCompleted);
    this.close();
    this.router.navigate(['/analysis']);
    this.translate.get('SAVE_SURVEY_200.TITLE').subscribe((res: string) => {
      this.toastr.success(res, null, {
        positionClass: 'toast-top-center',
        timeOut: 2000
      })
    }, error => {
      this.toastr.error(error, null, {
        positionClass: 'toast-top-center',
        timeOut: 2000
      })
    });
  }

  //Method used to send survey completed;
  sendButton() {
    this.completedSurvey.isCompleted = true;
    this.surveyUpsert(this.completedSurvey.isCompleted);
    this.close();
  }

  //Method used to check answerDictionary is empty.
  isEmpty() {
    for (var key in this.answerDictionary) {
      if (key != '') { return false }
    }
    return true
  }

  //API return Survey
  getSurvey() {
    //Call Api of survey service that return survey.
    this.surveyService.getSurvey(this.idElaboration)
      .subscribe(
        data => {
          this.survey = data;
          switch (this.state) {
            case 'CompilazioneNonAvviata': {
              this.createData(this.survey.Pages);
              break;
            }
            case 'CompilazioneParziale': {
              this.surveyRead();

              break;
            }
          }
        },
        error => {
          this.router.navigate(['/errorPage']);
        });
  }

  //API Send Survey
  surveyUpsert(isCompleted: boolean) {
    //Call Api of survey service that send survey.
    this.surveyService.surveyUpsert(this.completedSurvey)
      .subscribe(
        data => {
          if (isCompleted == true) {
            this.router.navigate(['/analysis'])
            this.translate.get('SEND_SURVEY_200.TITLE').subscribe((res: string) => {
              this.toastr.success(res, null, {
                positionClass: 'toast-top-center',
                timeOut: 2000
              })
            });
          }
        },
        error => {
          this.router.navigate(['/errorPage']);
        }
      );
  }

  // API Read Survey
  surveyRead() {
    //Check status of current facility.
    switch (this.state) {
      case 'CompilazioneConclusa': {
        this.surveyService.surveyRead(this.idElaboration)
          .subscribe(
            data => {
              this.surveyToRead = data;
            },
            error => {
              this.router.navigate(['/errorPage']);
            });
      }
      case 'CompilazioneParziale': {
        this.surveyService.surveyRead(this.idElaboration)
          .subscribe(
            data => {
              this.partialSurvey = data;
              for (let page of this.partialSurvey.Pages) {
                for (let section of page.Sections) {
                  for (let question of section.QuestionsCompiled) {
                    if (question.AnswerText != "") {
                      this.answerDictionary[question.AnswerId] = { Text: question.AnswerText, QuestionRefID: question.QuestionId };
                    }
                  }
                }
              }
              this.createDataPartial(this.partialSurvey.Pages);
              this.isEmpty();
            },
            error => {
              this.router.navigate(['/errorPage']);
            });
      }
    }

  }
}
